import React from "react";
import backgroundImg from "../assets/images/IMG_0655.jpg";



function Home() {
  return (
    <div className="home"
      style={{
        backgroundImage: `url(${backgroundImg})`,
        
      }}
    >
     
    </div>
  );
}

export default Home;
